import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import apiFetch from '@wordpress/api-fetch'

const btn = document.querySelector('[js-event-btn]')
const modal = document.querySelector('[js-event-modal]')
const closeBtn = document.querySelector('[js-event-close]')
const disableBtn = document.querySelector('[js-event-disable]')
const form = document.querySelector('[js-event-form]')

if (modal && btn) {
  btn.addEventListener('click', () => {
    modal.classList.add('is-open')
    disableBodyScroll(document.documentElement)
    disableBodyScroll(document.body)
  })

  closeBtn.addEventListener('click', () => {
    modal.classList.remove('is-open')
    enableBodyScroll(document.documentElement);
    enableBodyScroll(document.body);
  })

  disableBtn.addEventListener('click', () => {
    modal.classList.remove('is-open')
    enableBodyScroll(document.documentElement);
    enableBodyScroll(document.body);
  })



  // FORM

  const other = modal.querySelector('.form-event-other')
  const catSelect = modal.querySelector('.form-event-cat')
  const name = modal.querySelector('#form-event-name')
  const date = modal.querySelector('#form-event-date')
  const location = modal.querySelector('#form-event-location')
  const content = modal.querySelector('#form-event-desc')
  const contact = modal.querySelector('#form-event-contact')
  const successMsg = modal.querySelector('.agenda-success')
  const errorMsg = modal.querySelector('.agenda-error')

  let data = {
    title: null,
    type: null,
    date: null,
    location: null,
    content: null,
    contact: null,
    cat: modal.querySelector('.form-event-category').value
  }

  catSelect.addEventListener('change', () => {
    if (catSelect.value === 'autre') {
      other.classList.add('is-appear')
      data.type = null
    } else {
      data.type = catSelect.value
      other.classList.remove('is-appear')
    }
  })

  other.addEventListener('change', () => {
    data.type = other.value !== '' ? type.value : null
  })
  
  name.addEventListener('change', () => {
    data.title = name.value !== '' ? name.value : null
  })

  location.addEventListener('change', () => {
    data.location = location.value !== '' ? location.value : null
  })
  date.addEventListener('change', () => {
    data.date = date.value !== '' ? date.value : null
  })
  content.addEventListener('change', () => {
    data.content = content.value !== '' ? content.value : null
  })
  contact.addEventListener('change', () => {
    data.contact = contact.value !== '' ? contact.value : null
  })

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    let valid = true
    let error = null

    successMsg.innerHTML = ''
    errorMsg.innerHTML = ''

    if (!data.title || !data.date || !data.type || !data.location || !data.content) {
      valid = false 
      error = 'Tous les champs sont requis'
    }

    if (valid) {
      // console.log(modal.querySelector('.form-event-category').value)
      const resEvent = await apiFetch({
        path: `/wp-json/ad/v1/event`,
        method: 'POST',
        data: data,
      })

      if (resEvent.success) {
        successMsg.innerHTML = 'L\'evenement a été envoyé avec succès. Il est désormais soumis à validation.'
        
        data = {
          title: null,
          type: null,
          date: null,
          location: null,
          content: null,
          contact: null,
        }

        other.value = ''
        location.value = ''
        date.value = ''
        content.value = ''
        name.value = ''
        catSelect.value = ''
        contact.value = ''
        
      } else {
        errorMsg.innerHTML = resEvent.error
      }
    } else {
      errorMsg.innerHTML = error
    }
  })
}